// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.get_app {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size: 16px;
}

.form-group {
    /* font-family: 'Trebuchet MS','Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif; */
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;    
    color: black;
    text-align: left;
    font-size: 18px;
    margin-top: 10px;
  }


.form-group label {
    font-size: 18px;
    /* font-family: 'Trebuchet MS','Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif; */
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    color: black;
    text-align: left; /* Forces left alignment */
    margin-top: 10px;
  }

.form-box-header {
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .logo-default-container-img {
    margin-left: 30px;
    width: 70px;
    height: 70px;
    margin-top: 10px;
    border-radius: 20px;
  }

  /* Two Inputs in One Row */
.form-group-row {
    display: flex;
    justify-content: space-between;
    gap: 20px; 
  }
  
  .form-group-row .form-group {
    flex: 1 1;
    display: flex;
    flex-direction: column;
  }

`, "",{"version":3,"sources":["webpack://./src/components/Pages/PublicLayout/Styles/common-formstyle.css"],"names":[],"mappings":";AACA;IACI,4DAA4D;IAC5D,eAAe;AACnB;;AAEA;IACI,0GAA0G;IAC1G,mJAAmJ;IACnJ,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;;;AAGF;IACI,eAAe;IACf,0GAA0G;IAC1G,mJAAmJ;IACnJ,YAAY;IACZ,gBAAgB,EAAE,0BAA0B;IAC5C,gBAAgB;EAClB;;AAEF;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,0BAA0B;AAC5B;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;EACxB","sourcesContent":["\n.get_app {\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    font-size: 16px;\n}\n\n.form-group {\n    /* font-family: 'Trebuchet MS','Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif; */\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;    \n    color: black;\n    text-align: left;\n    font-size: 18px;\n    margin-top: 10px;\n  }\n\n\n.form-group label {\n    font-size: 18px;\n    /* font-family: 'Trebuchet MS','Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif; */\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    color: black;\n    text-align: left; /* Forces left alignment */\n    margin-top: 10px;\n  }\n\n.form-box-header {\n    border-radius: 10px;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n  }\n\n  .logo-default-container-img {\n    margin-left: 30px;\n    width: 70px;\n    height: 70px;\n    margin-top: 10px;\n    border-radius: 20px;\n  }\n\n  /* Two Inputs in One Row */\n.form-group-row {\n    display: flex;\n    justify-content: space-between;\n    gap: 20px; \n  }\n  \n  .form-group-row .form-group {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
